import React from "react";
import { IconButton, TextField } from "material-ui";

class QuantityEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: props.quantity
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    let quantity = e.target.value;

    // Allow negative signs as an intermediate character
    if (quantity === "-") {
      return this.setState({ quantity });
    }

    // Ignore non-numeric characters
    if (quantity && quantity != +quantity) {
      return;
    }

    if (typeof quantity !== "undefined") {
      // make whole
      quantity = Math.ceil(quantity);

      if (typeof this.props.max !== "undefined" && quantity > this.props.max) {
        quantity = this.props.max;
      } else if (
        typeof this.props.min !== "undefined" &&
        quantity < this.props.min
      ) {
        quantity = this.props.min;
      }
      this.props.updateQuantity(quantity);
    }

    this.setState({ quantity });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.quantity !== this.state.quantity) {
      this.setState({ quantity: newProps.quantity });
    }
  }

  render() {
    return (
      <div style={this.props.style}>
        <IconButton
          iconStyle={{ fontSize: 12 }}
          iconClassName="icon-minus"
          onTouchTap={() =>
            this.onChange({ target: { value: this.state.quantity - 1 } })
          }
          disabled={this.state.quantity === this.props.min}
        />
        <TextField
          name="quantity"
          value={this.state.quantity}
          onChange={this.onChange}
          style={{ width: 20 }}
        />
        <IconButton
          iconStyle={{ fontSize: 12 }}
          iconClassName="icon-plus"
          onTouchTap={() =>
            this.onChange({ target: { value: this.state.quantity + 1 } })
          }
          disabled={this.state.quantity === this.props.max}
        />
      </div>
    );
  }
}

export default QuantityEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/quantity-editor.jsx